import { InjectionToken } from '@angular/core';

export const FILE_EXPORT_POLLING_TIME = new InjectionToken<number>('File Export Pulling Time');
